<template>
  <q-page class="bim-smeta-handbook q-px-md q-pt-md">
    <div class="bim-smeta-handbook__toolbar row items-start q-mb-md" style="gap: 12px;">
      <div class="row items-center no-wrap" style="gap: 8px;">
        <q-btn
          outline
          color="primary"
          no-caps
          icon="close"
          label="Закрыть"
          @click="tryCloseTab"
        />
        <q-btn
          outline
          color="primary"
          no-caps
          icon="arrow_back"
          label="К проектам"
          :to="backToProjectsRoute"
        />
      </div>
      <div class="col">
        <div class="text-h6">BIM-смета</div>
        <div class="text-body2 text-grey-7 bim-smeta-handbook__subtitle">
          {{ headerSubtitle }}
        </div>
      </div>
    </div>

    <q-banner v-if="!projectId" dense rounded class="bg-orange-2 text-dark">
      Не указан project_id в адресе страницы. Откройте справочник из действия «BIM-смета» в списке проектов.
    </q-banner>

    <div v-else class="bim-smeta-handbook__body">
      <ProjectBimDigitalCompare
        handbook-page
        :project-id="projectId"
        :resident-id="residentId"
        :project-type-id="projectTypeId"
        @error="onCompareError"
      />
    </div>
  </q-page>
</template>

<script>
import { PAGES } from '@/constants';
import ProjectBimDigitalCompare from '@/views/ProjectsEntry/ProjectBimDigitalCompare.vue';

function parseQueryInt(value) {
  if (value == null || value === '') return null;
  const n = parseInt(String(value), 10);
  return Number.isNaN(n) ? null : n;
}

export default {
  name: 'ProjectBimSmetaHandbook',
  components: { ProjectBimDigitalCompare },
  computed: {
    projectId() {
      return parseQueryInt(this.$route.query.project_id);
    },
    residentId() {
      return parseQueryInt(this.$route.query.resident_id);
    },
    projectTypeId() {
      return parseQueryInt(this.$route.query.project_type_id);
    },
    headerSubtitle() {
      const parts = [];
      const rn = this.$route.query.resident_name;
      const ptn = this.$route.query.project_type_name;
      if (rn) parts.push(String(rn));
      if (ptn) parts.push(String(ptn));
      if (this.projectId) parts.push(`проект #${this.projectId}`);
      return parts.length ? parts.join(' · ') : 'Сравнение BIM — цифра и цифра — смета';
    },
    backToProjectsRoute() {
      const q = { tab: 'projects_overview' };
      if (this.residentId != null) q.resident_id = String(this.residentId);
      if (this.projectTypeId != null) q.project_type_id = String(this.projectTypeId);
      return { path: PAGES.projectsEntry, query: q };
    },
  },
  methods: {
    tryCloseTab() {
      window.close();
    },
    onCompareError(msg) {
      this.$q.notify({
        type: 'negative',
        message: msg || 'Ошибка',
        timeout: 8000,
      });
    },
  },
};
</script>

<style scoped>
/* На весь видимый viewport: скролл только внутри таблицы сметы (см. ProjectBimDigitalCompare) */
.bim-smeta-handbook {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: calc(100vh - 12px);
  max-height: calc(100dvh - 12px);
  overflow: hidden;
  overflow-x: hidden;
  box-sizing: border-box;
}

.bim-smeta-handbook__toolbar {
  flex: 0 0 auto;
  min-width: 0;
}

.bim-smeta-handbook__toolbar .col {
  min-width: 0;
}

.bim-smeta-handbook__body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-x: hidden;
}

.bim-smeta-handbook__subtitle {
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>
